import { createStore } from 'vuex'
import VuexPersist from 'vuex-persist'
import { get, set, del } from 'idb-keyval'

const idbStorage = {
  getItem: key => get(key),
  setItem: (key, value) => set(key, JSON.parse(JSON.stringify(value))), // ← Double safety
  removeItem: key => del(key)
}

const vuexPersist = new VuexPersist({
  key: 'easyHMO',
  // storage: window.sessionStorage,
  storage: idbStorage,
  asyncStorage: true, // Required for IndexedDB
  reducer: (state) => ({ loginHistory: state.loginHistory, user: state.user, cluster: state.cluster, cache: state.cache })
})

export default createStore({
  state: {
    loginHistory: null,
    user: null,
    cluster: null,
    cache: [],
    dashboardFreshSignin: false,
  },
  plugins: [vuexPersist.plugin],
  getters: {
  },
  mutations: {
    loadLoginHistory(state, payload) {
      state.loginHistory = payload;
    },
    loadUser(state, payload) {
      state.user = payload;
    },
    loadCluster(state, payload) {
      state.cluster = payload;
    },
    loadCache(state, payload) {
      state.cache = payload;
    },
    loadDashboardFreshSignin(state, payload) {
      state.dashboardFreshSignin = payload;
    },
  },
  actions: {
  },
  modules: {
  }
})
